import { render, staticRenderFns } from "./EmployeeGroupsForm.vue?vue&type=template&id=bbc21680&"
import script from "./EmployeeGroupsForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeGroupsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports